export default {
  geolocation: {
    lat: '-0.218611',
    lng: '-78.509722',
    label: '170107 Quito',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
